<template>
  <div class="mysection bgwhite">
    <div class="pjshare">
      <ul>
        <li>
          <h4>{{form.creditorName}}：{{form.projectCode}}</h4>
          <el-row class="idata">
            <el-col :span="18" class="color_666">转让金额</el-col>
            <el-col :span="6" class="talign_r"><span class="color_red bold">{{form.amount}}<sub>元</sub></span></el-col>
          </el-row>
          <el-row class="idata">
            <el-col :span="18" class="color_666">预期收益率</el-col>
            <el-col :span="6" class="talign_r"><span class="color_red bold">{{form.yieldRate}}<sub>%</sub></span></el-col>
          </el-row>
          <el-row class="idata">
            <el-col :span="18" class="color_666">剩余期限</el-col>
            <el-col :span="6" class="talign_r"><span>{{form.deadline}}<sub>天</sub></span></el-col>
          </el-row>
          <el-row class="ml_desc">
            <el-col :span="8" class="color_666">还款方式</el-col>
            <el-col :span="16" class="talign_r"><span>{{form.repaymentMethod}}</span></el-col>
          </el-row>
          <el-row class="ml_desc">
            <el-col :span="8" class="color_666">要求保证方式</el-col>
            <el-col :span="16" class="talign_r"><span>{{form.guaranteeMethod}}</span></el-col>
          </el-row>
        </li>
      </ul>

    </div>
    <div class="ad_qrcode">
      <!-- <img :src="downloadFileURL+this.form.quickMark+'/'" /> -->
      <img src="../../assets/images/qrcode_bottom.jpg" />
      <p>长按关注公众号，惊喜等待你！</p>
    </div>

    <div class="btns_bottom">
      <a class="btn_b" v-on:click="toWxMyAssignmentDebtDetail(projectId)">约谈项目</a>
    </div>
  </div>
</template>
<script>
  import {reqGetOneAssignmentDebt} from '../../api/weixin-api';
  import {reqGetDictionaryByIdList,downloadFileURL} from '../../api/weixin-api';

  export default {
    data(){
      return{
        form: {
          id:'',
          projectName:'',
          projectCode:'',
          amount:'',
          deadline:'',
          yieldRate:'',
          repaymentMethod:'',
          guaranteeMethod:'',
          projectDescription:'',
          quickMark:''
        },
        projectId:'',
        downloadFileURL:downloadFileURL,
      }
    },
    methods:{
      getProjectByid:function (id) {
        var that=this;
        reqGetOneAssignmentDebt({id:id}).then((res)=>{
          that.form = Object.assign({}, res.data.data);
          reqGetDictionaryByIdList({ids: that.form.repaymentMethod}).then((res) => {
            var dictionarys = res.data.data;
            dictionarys.forEach(function (obj, i) {
              return that.form.repaymentMethod = obj.name;
            });
          });
          var gm = that.form.guaranteeMethod;
          if(gm != null && gm != '') {
            reqGetDictionaryByIdList({ids: gm}).then((res) => {
              var dictionarys = res.data.data;
              gm = '';
              dictionarys.forEach(function (obj, i) {
                gm += obj.name;
                if (i < (dictionarys.length - 1)){
                  gm += ', ';
                }
              });
              return that.form.guaranteeMethod = gm;
            });
          }
        })
      },
      toWxMyAssignmentDebtDetail(projectId){
        window.open("https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx3557168303054c37&redirect_uri=http%3a%2f%2fwww.phjd365.com%2fmp&response_type=code&scope=snsapi_userinfo&state="+projectId+"PLR"+"assignment"+"WX"+"wxAssignmentDebtSharing"+"#wechat_redirect");
      },
      isWechatBrowser: function () {
        let that=this;
        let ua = navigator.userAgent.toLowerCase();
        let isWeixin = ua.indexOf('micromessenger') !== -1;
        if (!isWeixin) {
          that.$router.push({name: 'wxError'});
        }
      },
      backWeiXin:function() {
        pushHistory();

        function bodyScroll() {
          var state = {
            title: "title",
            url: ""
          };
          window.history.pushState(state, state.title, state.url);
//              window.location.href ='/wxMyHomePage';
        }

        window.addEventListener("popstate", bodyScroll, false)
        function pushHistory() {
          var state = {
            title: "title",
            url: ""
          };
          window.history.pushState(state, state.title, state.url);
        }
      }

    },
    mounted(){
      this.$store.dispatch('hideHF');
      var row=this.$route.query;
        this.backWeiXin()
      this.projectId=row.id;
      this.getProjectByid(row.id);
      this.isWechatBrowser();
    }
  }
</script>
<style slot-scope="scope">
    @import '../../assets/css/wxstyle.css';
</style>



// WEBPACK FOOTER //
// src/components/weChat/WxAssignmentDebtSharing.vue